module.exports = __webpack_public_path__ + "static/debt--updated-and-expanded-780caf267c9d6bee9ac94e3e905c1c08.jpg";